import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductDeletedService {
  private productDeleted = new EventEmitter<number>();

  public getProductDeletedSubscribable(): Subject<number> {
    return this.productDeleted;
  }

  public productWasDeleted(id: number): void {
    this.productDeleted.emit(id);
  }
}
